import React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Bell } from 'lucide-react';

interface Props {
  open: boolean;
  busy?: boolean;
  onAccept: () => void;
  onLater: () => void;
}

const items = [
  ['☀️', 'Morning wellness check-ins'],
  ['💙', 'Daily affirmations'],
  ['👀', 'Question of the Day'],
  ['🌙', 'Evening wellness reminders'],
  ['💬', 'Replies, likes & comments'],
];

const NotificationPrePrompt: React.FC<Props> = ({ open, busy, onAccept, onLater }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o && !busy) onLater(); }}>
    <DialogContent className="sm:max-w-sm mx-auto rounded-2xl p-0 overflow-hidden [&>button]:hidden">
      <div className="flex flex-col items-center px-6 py-7 space-y-5">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
          <Bell className="h-7 w-7 text-primary" />
        </div>
        <div className="text-center space-y-2">
          <DialogTitle className="text-xl font-bold">Stay in the loop 💙</DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            Vent can send you a few helpful reminders throughout the day, plus let you know when people interact with your vents.
          </DialogDescription>
        </div>
        <ul className="w-full space-y-2 text-sm">
          {items.map(([icon, label]) => (
            <li key={label} className="flex items-center gap-3 rounded-lg bg-muted/60 px-3 py-2">
              <span aria-hidden>{icon}</span>
              <span className="font-medium text-foreground">{label}</span>
            </li>
          ))}
        </ul>
        <div className="w-full space-y-2">
          <Button className="w-full" size="lg" onClick={onAccept} disabled={busy}>
            Turn On Notifications
          </Button>
          <Button variant="ghost" className="w-full text-muted-foreground" onClick={onLater} disabled={busy}>
            Maybe Later
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default NotificationPrePrompt;
